import { FC } from 'react';
import SendFormsModal from './components/send-forms-modal.component';
import SendFormsSteps from './components/steps/send-forms-steps.component';
import { useSendFormsContext } from './providers/context';
import type { UseSendFormsProvidersProps } from './providers/hooks/useSendFormsProviders';
import { SendFormsWrapper } from './providers/wrapper';

type DigitalFormsSendingExperienceProps = UseSendFormsProvidersProps;

const SendFormsContent: FC = () => {
  const context = useSendFormsContext();
  const mode = context.mode ?? 'standalone';

  // In embedded mode, render steps directly without modal wrapper
  if (mode === 'embedded') {
    return <SendFormsSteps />;
  }

  // In standalone mode, render the modal (default behavior)
  return <SendFormsModal />;
};

export const DigitalFormsSendingExperience: FC<DigitalFormsSendingExperienceProps> = (props) => {
  return (
    <SendFormsWrapper {...props}>
      <SendFormsContent />
    </SendFormsWrapper>
  );
};
